<script setup lang="ts">
import { watch } from 'vue'

import { useSwitchTeamColors } from '@desktop/views/Relation/composables'
import { setTeamSidesColors } from '@desktop/views/Relation/utils'

import EventSettingsSwitch from './EventSettingsSwitch.vue'

// composables
const { isSwitchedTeamColors } = useSwitchTeamColors()

// init
watch(isSwitchedTeamColors, setTeamSidesColors)
</script>

<template>
  <EventSettingsSwitch settingName="teamColorsSwitched">
    <span class="w-20">Team colors switched</span>
  </EventSettingsSwitch>
</template>
